module.exports = __webpack_public_path__ + "img/M0071.bec318de.png";